<div class="container" >
  <h1 class="text-center bg-warning">Blood Group Report</h1>

    <div class="row">

        <mat-form-field appearance="outline" class="col-md-4">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input  [rangePicker]="picker">
                <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
                <input matEndDate [(ngModel)]="endDate" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>


<!--  <mat-form-field appearance="outline" class="col-md-4">-->
<!--    <mat-label>Select Centre</mat-label>-->
<!--    <mat-select #selectElement   [(ngModel)]="selectedCentreCode">-->
<!--        <mat-option value='All'>All</mat-option>-->
<!--      <mat-option *ngFor=" let c of (centres$|async)  "-->
<!--                  [value]="c.centreCode">{{c.centreName}} </mat-option>-->
<!--      &lt;!&ndash;      <mat-option  value="All">All Centres</mat-option>&ndash;&gt;-->
<!--    </mat-select>-->
<!--  </mat-form-field>-->

      <app-searchable-select class="col-md-4"
                             [(ngModel)]="selectedCentreCode"
                             [options]="centres$ | async"
                             [selectedValue]="selectedCentre"
                             [displayWithFn]="displayCentre"
                             [placeholder]="'Select Centre'"

                             [label]="'Select Centre'"
                             (selectionChange)="onCentreSelect($event)"
      ></app-searchable-select>

    <button mat-mini-fab color="accent" (click)="search2()"><mat-icon>search</mat-icon></button>
      <button  class="mx-2" mat-mini-fab color="accent" (click)="Clear()"><mat-icon>clear</mat-icon></button>

</div>

    <div class="d-flex justify-content-between">
<div>
      <mat-form-field appearance="outline" *ngIf="dataSource.data.length>=1">
        <mat-label>Select Blood Group</mat-label>
        <mat-select [(ngModel)]="selectedBloodGroup" (selectionChange)="onGroupSelecte($event)">
          <mat-option value='All'>All</mat-option>

          <mat-option *ngFor="let bloodGroup of bloodGroupTypes!!" [value]="bloodGroup">
            {{ bloodGroup }}
          </mat-option>
        </mat-select>
      </mat-form-field>
</div>
    </div>

  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Blood Group Report</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <!--      <li>-->
      <!--        <button   mat-mini-fab color="primary" (click)="openAddCarLog()">-->
      <!--          <mat-icon class="col-white" >add</mat-icon>-->
      <!--        </button>-->
      <!--      </li>-->
      <li>
        <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Blood Group Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
          <img src="assets/images/icons/xlsx.png" alt="" />
        </div>
      </li>
    </ul>
  </div>


    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table table-striped table-bordered"   id="excel-table">

    <!-- Child Name Column -->
    <ng-container matColumnDef="childName">
      <th mat-header-cell *matHeaderCellDef> Child Name </th>
      <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
    </ng-container>

    <ng-container matColumnDef="childCode">
      <th mat-header-cell *matHeaderCellDef> Child Code </th>
      <td mat-cell *matCellDef="let element" class="TextWidth"> {{element.childCode}} </td>
    </ng-container>

    <ng-container matColumnDef="gender">
      <th mat-header-cell *matHeaderCellDef> Gender </th>
      <td mat-cell *matCellDef="let element"> {{element.gender}} </td>
    </ng-container>

    <!-- Age Column -->
    <ng-container matColumnDef="age">
      <th mat-header-cell *matHeaderCellDef> Age </th>
      <td mat-cell *matCellDef="let element"> {{element.age}} </td>
    </ng-container>

    <!-- Blood Group Column -->
    <ng-container matColumnDef="bloodGroup">
      <th mat-header-cell *matHeaderCellDef> Blood Group </th>
      <td mat-cell *matCellDef="let element"> {{element.bloodGroup}} </td>
    </ng-container>


 <ng-container matColumnDef="parentsName">
      <th mat-header-cell *matHeaderCellDef> Parents Name </th>
      <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.parentsName" matTooltipPosition="above"> {{element.parentsName}} </td>
    </ng-container>

    <!-- Hospital Column -->
    <ng-container matColumnDef="hospital">
      <th mat-header-cell *matHeaderCellDef> Hospital </th>
      <td mat-cell *matCellDef="let element" class="truncate-text" [matTooltip]="element.hospital" matTooltipPosition="above"> {{element.hospital}} </td>
    </ng-container>

    <!-- Centre Name Column -->
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef> Centre Name </th>
      <td mat-cell *matCellDef="let element" class="TextWidth"> {{element.centreName}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 500]" showFirstLastButtons></mat-paginator>

</div>
